<div class="grid-stack-container">
  <gridstack [options]="gridOptions" (changeCB)="onChange()"></gridstack>
</div>
